import React, { memo, useCallback, useEffect, useRef } from 'react';
import { StyleSheet } from 'react-native';
import { Amplitude } from 'utils';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { CardView, rem, TextButtonLinkSeeAll } from 'design-system';
import { RewardsGroup } from 'features/rewards/components/RewardsGroup';
import { useRewards } from 'features/rewards/hooks/useRewards';
import { useFocusEffect } from 'hooks';
import { selectFeedRewards } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import Section from './Section';
const CashbackCard = () => {
    const navigation = useMainStackNavigation();
    const { fetchRewards, isRewardsFetching, hasRewards, openReward } = useRewards();
    const rewards = useAppSelector(selectFeedRewards);
    const initialCallRan = useRef(false);
    useEffect(() => {
        if (!isRewardsFetching) {
            fetchRewards().then(() => {
                initialCallRan.current = true;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useFocusEffect(useCallback(() => {
        if (!isRewardsFetching && !hasRewards && initialCallRan.current) {
            fetchRewards();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchRewards, hasRewards]));
    const onOpenReward = useCallback((reward) => {
        Amplitude.logEvent('Open Reward', { source: 'rewards', reward });
        openReward(reward);
    }, [openReward]);
    const onPress = useCallback(() => {
        navigation.navigateDeprecated('Rewards');
    }, [navigation]);
    if (!rewards.length)
        return null;
    return (<Section title="Cashback offers" button={<TextButtonLinkSeeAll onPress={onPress}/>} style={styles.fraudDetectionSection}>
      <CardView noMarginTop noMarginBottom>
        <RewardsGroup largerText rewards={rewards} onRewardSelect={onOpenReward} contentContainerStyle={styles.rewardsGroup}/>
      </CardView>
    </Section>);
};
const styles = StyleSheet.create({
    fraudDetectionSection: {
        marginTop: rem(8),
    },
    rewardsGroup: {
        paddingVertical: rem(8),
    },
});
export default memo(CashbackCard);
